import { LanguageService } from './../services/LanguageHandler'

export default {
  uiLanguage: LanguageService.getLanguage(),
  supportedLanguages: LanguageService.getSupportedLanguages(),
  cache: {},
  user: {},
  userHasCV: false,
  pageSize: 9,
  metaInfo: {},
  reRenderPageCounter: 0,
  promoVideos: {
    en: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    ru: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    uk: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    da: {
      video_url: 'https://player.vimeo.com/external/293083475.sd.mp4?s=f2fcc747e720e05972c14d636bbdb32b0b1a1518&profile_id=165'
    },
    de: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    nb: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    fi: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    pl: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    lt: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    },
    hr: {
      video_url: 'https://player.vimeo.com/external/293085338.sd.mp4?s=e7d77c5479e0b14376d6bd3cf664f590b46928a3&profile_id=165'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/state.js